import { useEffect } from "react";

export const BRAND_FONTS = ["Cormorant Garamond", "Playfair Display", "Cinzel", "Montserrat", "Poppins", "Bebas Neue", "Great Vibes", "Plus Jakarta Sans"];
export const BRAND_COLORS = [["", "Gold gradient"], ["#D4AF37", "Solid gold"], ["#FFFFFF", "White"], ["#F7E7CE", "Champagne"]];
const LOADED = new Set(["Cormorant Garamond", "Plus Jakarta Sans"]);

export function useBrandFont(font) {
  useEffect(() => {
    if (!font || LOADED.has(font)) return;
    LOADED.add(font);
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = `https://fonts.googleapis.com/css2?family=${font.replace(/ /g, "+")}:wght@400;600;700&display=swap`;
    document.head.appendChild(l);
  }, [font]);
}

const splitBrand = (name) => {
  const dot = name.lastIndexOf(".");
  const base = dot > 0 ? name.slice(0, dot) : name;
  const suffix = dot > 0 ? name.slice(dot) : "";
  const m = base.match(/^(.+?)([A-Z][a-z]+)$/);
  return m ? [m[1], m[2], suffix] : [base, "", suffix];
};

// Brand name text with the admin-chosen font and colour ("" colour = gold gradient on the first word).
export default function BrandName({ name, color, font, className = "", testid }) {
  useBrandFont(font);
  const [gold, rest, suffix] = splitBrand(name || "CarSaleMarket.com");
  const style = font && font !== "Cormorant Garamond" ? { fontFamily: `'${font}', serif` } : {};
  return (
    <span className={`font-display font-semibold tracking-tight whitespace-nowrap ${className}`} style={style} data-testid={testid}>
      {color ? <span style={{ color }} data-testid={testid && `${testid}-colored`}>{gold}{rest}</span> : <><span className="gold-text">{gold}</span>{rest}</>}
      <span className="text-[#9CA3AF] text-[0.65em]">{suffix}</span>
    </span>
  );
}
